<template>
    <Modal2
        v-if="visible"
        design="v3"
        class-name="bulk-vip-modal"
        :show-footer="false"
        :show-title="false"
        @cancel="onCancel"
    >
        <div class="bulk-vip-modal-content">
            <div class="modal-section">
                <div class="selection-wrapper">
                    <div class="section-title">
                        <i class="material-icons">stars</i>
                        <span>VIP Durumu Seçin</span>
                    </div>

                    <div class="vip-options">
                        <div
                            class="vip-card"
                            :class="{ selected: vipCustomer === true }"
                            @click="vipCustomer = true"
                        >
                            <div class="card-icon vip-icon">
                                <i class="material-icons">star</i>
                            </div>
                            <div class="card-content">
                                <div class="card-title">VIP Müşteri</div>
                                <div class="card-description">
                                    Seçilen kişiler VIP olarak işaretlenecek ve özel öncelik kazanacak
                                </div>
                            </div>
                            <div class="selection-indicator">
                                <i v-if="vipCustomer === true" class="material-icons">check_circle</i>
                                <i v-else class="material-icons">radio_button_unchecked</i>
                            </div>
                        </div>

                        <div
                            class="vip-card"
                            :class="{ selected: vipCustomer === false }"
                            @click="vipCustomer = false"
                        >
                            <div class="card-icon normal-icon">
                                <i class="material-icons">person</i>
                            </div>
                            <div class="card-content">
                                <div class="card-title">Normal Müşteri</div>
                                <div class="card-description">
                                    VIP durumu kaldırılacak ve standart öncelik uygulanacak
                                </div>
                            </div>
                            <div class="selection-indicator">
                                <i v-if="vipCustomer === false" class="material-icons">check_circle</i>
                                <i v-else class="material-icons">radio_button_unchecked</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <SupsisButton @click="onCancel">İptal</SupsisButton>
                <SupsisButton primary @click="onConfirm">
                    <i class="material-icons">done</i>
                    Durumu Uygula
                </SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from "@/components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "BulkSetVipModal",
    components: { Modal2, SupsisButton },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            vipCustomer: null,
        };
    },
    methods: {
        onConfirm: function () {
            if (this.vipCustomer === null) {
                this.$message.warning("Lütfen bir VIP durumu seçiniz");
                return;
            }

            this.$emit("confirm", {
                action: "set-vip",
                payload: {
                    vipCustomer: this.vipCustomer,
                },
            });
            this.reset();
        },
        onCancel: function () {
            this.$emit("cancel");
            this.reset();
        },
        reset: function () {
            this.vipCustomer = null;
        },
    },
};
</script>

<style lang="scss">
.bulk-vip-modal {
    .custom-modal-body {
        padding: 0 !important;
    }

    .bulk-vip-modal-content {
        display: flex;
        flex-direction: column;
        min-height: 450px;

        .modal-section {
            flex: 1;
            padding: 28px;
            overflow-y: auto;
        }

        .selection-wrapper {
            .section-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 20px;
                padding-bottom: 12px;
                border-bottom: 2px solid #e8eaed;

                .material-icons {
                    font-size: 24px;
                    color: #22272d;
                }

                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #22272d;
                    letter-spacing: 0.3px;
                }
            }

            .vip-options {
                display: flex;
                flex-direction: column;
                gap: 16px;
            }

            .vip-card {
                display: flex;
                align-items: center;
                gap: 18px;
                padding: 20px;
                background: white;
                border: 2px solid #e8eaed;
                border-radius: 14px;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    border-color: #22272d;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(34, 39, 45, 0.12);
                }

                &.selected {
                    border-color: #22272d;
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    box-shadow: 0 4px 16px rgba(34, 39, 45, 0.1);

                    .card-icon {
                        transform: scale(1.05);
                    }
                }

                .card-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 56px;
                    height: 56px;
                    border-radius: 14px;
                    flex-shrink: 0;
                    transition: transform 0.3s ease;

                    &.vip-icon {
                        background: linear-gradient(135deg, #ffc107 0%, #ffb300 100%);
                        box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);

                        .material-icons {
                            font-size: 32px;
                            color: white;
                        }
                    }

                    &.normal-icon {
                        background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
                        box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);

                        .material-icons {
                            font-size: 32px;
                            color: white;
                        }
                    }
                }

                .card-content {
                    flex: 1;

                    .card-title {
                        font-size: 16px;
                        font-weight: 700;
                        color: #22272d;
                        margin-bottom: 6px;
                    }

                    .card-description {
                        font-size: 13px;
                        color: #6c757d;
                        line-height: 1.5;
                    }
                }

                .selection-indicator {
                    .material-icons {
                        font-size: 28px;
                        color: #22272d;
                        transition: all 0.2s ease;
                    }
                }
            }
        }

        .modal-footer {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 12px;
            padding: 20px 28px;
            border-top: 2px solid #e8eaed;

            .supsis-button {
                height: 44px;
                padding: 0 24px;
                font-size: 15px;
                border-radius: 10px;
                
                .material-icons {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
